<template>
    <div class="button-wrapper">
        <RouterLink class="button" :to="route" v-if="route">
            <slot></slot>
        </RouterLink>
        <a class="button" :href="href" v-else-if="href">
            <slot></slot>
        </a>
        <div :class="['button', {'button-active': loading}]" v-else>
            <div class="button-text">
                <slot></slot>
            </div>
            <img src="@/assets/images/spinner.gif" width="32" height="32" class="spinner" v-if="loading">
        </div>
    </div>
</template>

<script setup>




defineProps({
    route: {
        required: false,
        default: undefined
    },
    href: {
        required: false,
        default: undefined
    },
    loading: {
        default: false,
    }
})
</script>

<style scoped lang="scss">
.spinner {
    position: absolute;
    right: 1rem;
}

div.button-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button {
    position: relative;

    &-text {
        max-width: 100%;
        word-break: break-all;
    }

    background-color: transparent;
    display: flex;
    align-items: center;
    min-height: 3.625rem;
    font-family: 'Futura LT BT';
    font-weight: 300;
    font-size: 0.875rem;
    @include tracking(100);
    text-decoration: none;
    width: 16rem;
    max-width: 100%;
    box-sizing: border-box;
    text-align: center;

    &-active {
        border-color: transparent;
        background-color: $corporate-primary-color;
    }
}
</style>